export default __webpack_public_path__ + "static/media/de.fc1ad5b0.svg";